<script setup>
import {useStore} from "vuex";
import {computed, onMounted} from "vue";
const store = useStore()
onMounted( ()=>{
  store.commit('menuModule/initMenu')
})
const user = computed( () => {return store.getters['authModule/user']})
</script>

<template>
  <main class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col"><h3>Услуги и сервисы</h3></div>
        </div>
      </div>
    </section>
    <section class="content">
      <div class="container-fluid">

        <div class="row">
          <div class="col">
            Посещение АО МКК «СПб ЦДЖ» возможно только после предварительной записи по телефону (812) 640-57-22, доб. 3.
            <br>Консультационный центр находится по адресу: Санкт-Петербург, улица Серпуховская, д.2/68.
            <br>Время работы:
            <br>Пн.-Чт. с 9.00 до 19.00, Пт. с 9.00 до 18.00 без обеда
            <br>E-mail: <a href="mailTo:payments@spbcdg.ru">payments@spbcdg.ru</a>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-xl-3 col-md-6 col-sm-12">
            <router-link to="/application/payment" class="black-link">
              <div class="card card-outline card-orange">
                 <div class="card-body text-center">
                    <v-icon
                        class="service-icon--orange mb-3"
                        icon="mdi:wallet-outline"
                    ></v-icon>
                    <h6>Подготовить заявление<br>на частичное погашение</h6>
                  </div>
              </div>
            </router-link>
          </div>

          <div v-if="user !== null && +user['type'] === 1" class="col-xl-3 col-md-6 col-sm-12">
            <router-link to="/application/fns" class="black-link">
              <div class="card card-outline card-success">
                 <div class="card-body text-center">
                    <v-icon
                        class="service-icon--success mb-3"
                        icon="mdi:file-document-edit-outline"
                    ></v-icon>
                    <h6>Заказать справку<br>в Инспекцию ФНС</h6>
                  </div>
              </div>
            </router-link>
          </div>

          <div class="col-xl-3 col-md-6 col-sm-12">
            <router-link to="/application/pfr" class="black-link">
              <div class="card card-outline card-primary">
                <div class="card-body text-center">
                  <v-icon
                      class="service-icon mb-3"
                      icon="mdi:human-male-board-poll"
                  ></v-icon>
                  <h6>Заказать справку<br>в Пенсионный Фонд</h6>
                </div>
              </div>
            </router-link>
          </div>

          <div class="col-xl-3 col-md-6 col-sm-12">
            <router-link to="/application/credit" class="black-link">
              <div class="card card-outline card-success">
                <div class="card-body text-center">
                  <v-icon
                      class="service-icon--success mb-3"
                      icon="mdi:clipboard-text-clock-outline"
                  ></v-icon>
                  <h6>Заказать справку<br>о кредитной истории/акт сверки</h6>
                </div>
              </div>
            </router-link>
          </div>

          <div class="col-xl-3 col-md-6 col-sm-12">
            <router-link to="/application/balance" class="black-link">
              <div class="card card-outline card-danger">
                <div class="card-body text-center">
                  <v-icon
                      class="service-icon--danger mb-3"
                      icon="mdi:currency-rub"
                  ></v-icon>
                  <h6>Заказать справку<br>об остатке ссудной задолженности</h6>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
<style scoped>
.service-icon{
  width:40px;
  height:40px;
  color: #198bfe;
}
.service-icon--orange{
  width:40px;
  height:40px;
  color: #ff851b;
}
.service-icon--success{
  width:40px;
  height:40px;
  color: #28a745;
}
.service-icon--danger{
  width:40px;
  height:40px;
  color: #dc3545;
}
</style>